import {event} from '../modules/event';

var clipboardData = function(body){
    body.addEventListener('copy', function(e){
        var exception = ['/write/', '/about/'],
            isException = false,
            locationPath = location.pathname;

        /* К инпутам, textarea и на страницах с блочным редактором и о нас ничего не добавляем */
        if(e.target.nodeName === 'INPUT' || e.target.nodeName === 'TEXTAREA') return;
        exception.forEach(function(item){
            if(locationPath.indexOf(item) !== -1) {
                isException = true;
                return;
            }
        });
        if(isException) return;

        e.preventDefault();
        if (window.getSelection) {
            var selText = window.getSelection().toString();
            //var text = window.getSelection().toString() + ' Подробнее на ' + location.href;
            var text = window.getSelection().toString();
            if(e.clipboardData) e.clipboardData.setData('text/plain', text);
        }
    });
}

export {clipboardData};


